<h1 mat-dialog-title>
    <span translate>global.actions.ajouter</span>
    <span [mat-dialog-close]="true"><i class="zmdi zmdi-close"></i></span>
</h1>
<div mat-dialog-content>
    <form #form="ngForm">
        <div class="row">
            <custom-input ngDefaultControl
                          id="numero"
                          name="numero"
                          [(ngModel)]="compte.numero"
                          customType="input"
                          maxlength="20"
                          libelle="admin.frais.prestations.detail.generalites.donneesComptables.compteCharge.numero"
                          [required]="true">
            </custom-input>
        </div>
        <div class="row">
            <custom-input ngDefaultControl
                          id="libelle"
                          name="libelle"
                          [(ngModel)]="compte.libelle"
                          customType="input"
                          maxlength="50"
                          libelle="admin.frais.prestations.detail.generalites.donneesComptables.compteCharge.libelle"
                          [required]="true">
            </custom-input>
        </div>

        <div class="d-flex flex-row-reverse">
            <button mat-flat-button color="primary" class="ms-2"
                    (click)="add()"
                    [disabled]="form.invalid">
                <span [translate]="'global.actions.enregistrer'"></span>
            </button>
            <button mat-stroked-button color="primary"
                    (click)="matDialogRef.close(null)">
                <span [translate]="'global.actions.annuler'"></span>
            </button>
        </div>
    </form>
</div>
